import * as z from 'zod/v4';
import { EnumParams } from '../events.types';
import { priceSchema } from './event-sections.schemas';
import { rewardSchema } from './event-shared-object.schema';

export const ITEM_TIER_VALUES = ['Jackpot', 'Rare', 'Common'] as const;

const boxedGachaTierItemSchema = (enums?: EnumParams) =>
  z.object({
    item: rewardSchema(enums),
    count: z.number().int().nonnegative(),
  });

const boxedGachaTierSchema = (enums?: EnumParams) =>
  z.object({
    tier: z.enum(ITEM_TIER_VALUES),
    items: z.array(boxedGachaTierItemSchema(enums)),
    weight: z.number().optional(),
    allAvailableHeroes: z.boolean().optional(),
  });

export const boxedGachaSectionSchema = (enums?: EnumParams) =>
  z.object({
    singleCost: priceSchema(enums),
    bulkCost: priceSchema(enums),
    bulkAmount: z.number().int().nonnegative(),
    keyCurrency: priceSchema(enums).optional(),
    firstDrawIsFree: z.boolean(),
    countsForDailyKey: z.boolean(),
    tiers: z.array(boxedGachaTierSchema(enums)),
    // Deprecated in V2 and removed from the UI, but retained as optional so
    // existing pre-V2 events round-trip their stored values intact. Remove
    // once all old BoxedGacha events have been deleted.
    showInHub: z.boolean().optional(),
    closeDuration: z.iso.duration().optional(),
    chaseReward: rewardSchema(enums).optional(),
  });
